export default "__VITE_ASSET__BaVPVg3X__"